import Glide from "@glidejs/glide";
import { vacancyResponseInit } from "./vacancy-response";

import "@glidejs/glide/src/assets/sass/glide.core.scss";
import "@glidejs/glide/src/assets/sass/glide.theme.scss";

import "./index.scss";

onDomReady.then(() => {
  let slider = document.querySelector('.glide');
  if (slider) {
    new Glide('.glide', {}).mount();
  }
  
  vacancyResponseInit();
});